module.exports = __webpack_public_path__ + "static/media/Secondary_home.b7387bfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/png-images/Secondary_home.png
// module id = 3038
// module chunks = 0